import { CustomMessageService } from '../../core/message.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { PortfolioModel } from '../shared/models/portfolio-model';
import { PortfolioAccountManagerModel } from '../shared/models/portfolio-account-manager-model';
import { PortfolioService } from '../shared/services/portfolio.service';
import { LookupService } from '../../shared/services/lookup.service';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-portfolio-view-history',
  templateUrl: './portfolio-view-history.component.html',
  styleUrls: ['./portfolio-view-history.component.less'],
  standalone: false,
})
export class PortfolioViewHistoryComponent implements OnInit {
  constructor(
    private lookupService: LookupService,
    private portfolioService: PortfolioService,
    private config: ConfigurationService,
    private messageService: CustomMessageService,
    private translationService: TranslateService
  ) {}

  @Output()
  public onClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public display: boolean;
  @Input()
  public portfolio: PortfolioModel;

  public portfolioAccountManagerList: PortfolioAccountManagerModel[];

  public dateFormat: string;

  public specialDateFormat: string;

  public onPortfolioViewHistoryClick() {
    this.portfolioService
      .getPortfolioHistory(this.portfolio.portfolioId)
      .subscribe((d) => (this.portfolioAccountManagerList = d.items));
    this.onClick.emit(true);
  }

  public onCloseClick() {
    this.onClose.emit(false);
  }

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    let config = this.config.getCachedConfig();
    this.dateFormat = config.dateFormat; //TODO get from config
  }
}
